import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import ManagersTable from '../components/managersTable';

function Management() {
    return (
        <Layout>
            <SEO
                keywords={[
                    `Руководство`,
                    `Профф`,
                    `Пыть-Ях`,
                    `Профессиональное образование`,
                ]}
                title="Руководство"
            />

            <section className="flex flex-col items-center ">
                <h1 className=" text-center text-xl uppercase tracking-wider text-green-800 font-bold mb-4">
                    Руководство
                </h1>
                <ManagersTable />
            </section>
        </Layout>
    );
}

export default Management;
